import { PageProps } from "@/getServerSideProps/getServerSideProps";

export function StructuredData({
  productListingData,
}: Pick<PageProps, "productListingData">) {
  const defaultVariantCanonicalUrls = productListingData.products
    .map(
      (product) =>
        product.colorSwatches.find(
          (colorSwatch) => colorSwatch.isColorOfDefaultVariant === true,
        )?.canonicalURL,
    )
    .filter((url): url is string => Boolean(url));

  const structuredData = {
    "@type": "ItemList",
    "@context": "https://schema.org",
    numberOfItems: `(${defaultVariantCanonicalUrls.length})`,
    itemListElement: defaultVariantCanonicalUrls.map((url, i) => ({
      "@type": "ListItem",
      url: `https://www.johnlewis.com${url}`,
      position: i + 1,
    })),
  };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
}
